import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function IndustrySegmentReach({ industryAndSegmentReach }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  const dummyData = [
    {
      competitor: "a",
      primary_industry_focus: "b",
      customer_segments: "c",
      key_use_cases: "d",
      penetration_level: "e",
      adoption_maturity: "f",
      momentum: "f",
      key_customers: "f",
      primary_industry_focus_positive_insight: "b",
      primary_industry_focus_negative_insight: "b",
      primary_industry_focus_recent_development: "b",
      customer_segments_positive_insight: "c",
      customer_segments_negative_insight: "c",
      customer_segments_recent_development: "c",
      key_use_cases_positive_insight: "d",
      key_use_cases_negative_insight: "d",
      key_use_cases_recent_development: "d",
      penetration_level_positive_insight: "e",
      penetration_level_negative_insight: "e",
      penetration_level_recent_development: "e",
      adoption_maturity_positive_insight: "f",
      adoption_maturity_negative_insight: "f",
      adoption_maturity_recent_development: "f",
      momentum_positive_insight: "f",
      momentum_negative_insight: "f",
      momentum_recent_development: "f",
      key_customers_positive_insight: "f",
      key_customers_negative_insight: "f",
      key_customers_recent_development: "f",
    },
    {
      competitor: "a",
      primary_industry_focus: "b",
      customer_segments: "c",
      key_use_cases: "d",
      penetration_level: "e",
      adoption_maturity: "f",
      momentum: "f",
      key_customers: "f",
      primary_industry_focus_positive_insight: "b",
      primary_industry_focus_negative_insight: "b",
      primary_industry_focus_recent_development: "b",
      customer_segments_positive_insight: "c",
      customer_segments_negative_insight: "c",
      customer_segments_recent_development: "c",
      key_use_cases_positive_insight: "d",
      key_use_cases_negative_insight: "d",
      key_use_cases_recent_development: "d",
      penetration_level_positive_insight: "e",
      penetration_level_negative_insight: "e",
      penetration_level_recent_development: "e",
      adoption_maturity_positive_insight: "f",
      adoption_maturity_negative_insight: "f",
      adoption_maturity_recent_development: "f",
      momentum_positive_insight: "f",
      momentum_negative_insight: "f",
      momentum_recent_development: "f",
      key_customers_positive_insight: "f",
      key_customers_negative_insight: "f",
      key_customers_recent_development: "f",
    },
    {
      competitor: "a",
      primary_industry_focus: "b",
      customer_segments: "c",
      key_use_cases: "d",
      penetration_level: "e",
      adoption_maturity: "f",
      momentum: "f",
      key_customers: "f",
      primary_industry_focus_positive_insight: "b",
      primary_industry_focus_negative_insight: "b",
      primary_industry_focus_recent_development: "b",
      customer_segments_positive_insight: "c",
      customer_segments_negative_insight: "c",
      customer_segments_recent_development: "c",
      key_use_cases_positive_insight: "d",
      key_use_cases_negative_insight: "d",
      key_use_cases_recent_development: "d",
      penetration_level_positive_insight: "e",
      penetration_level_negative_insight: "e",
      penetration_level_recent_development: "e",
      adoption_maturity_positive_insight: "f",
      adoption_maturity_negative_insight: "f",
      adoption_maturity_recent_development: "f",
      momentum_positive_insight: "f",
      momentum_negative_insight: "f",
      momentum_recent_development: "f",
      key_customers_positive_insight: "f",
      key_customers_negative_insight: "f",
      key_customers_recent_development: "f",
    },
  ];

  useEffect(() => {
    const tableData = transformResultsToTableData(industryAndSegmentReach);
    setTabData(tableData);
    // setTabData(dummyData);
    console.log("TABLE DATA: " + JSON.stringify(tableData));
  }, [industryAndSegmentReach]);

  const tableColumns = [
    { key: "primary_industry_focus", label: "Primary Industry Focus" },
    { key: "customer_segments", label: "Customer Segments" },
    { key: "key_use_cases", label: "Key Use Cases" },
    { key: "penetration_level", label: "Penetration Level", width: "100px" },
    { key: "adoption_maturity", label: "Adoption Maturity" },
    { key: "momentum", label: "Momentum" },
    { key: "key_customers", label: "Key Customers" },
  ];

  return (
    <InsightTable
      title="Industry & Segment Reach"
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default IndustrySegmentReach;
